import { render, staticRenderFns } from "./Modal.pug?vue&type=template&id=462fe68e&lang=pug&"
import script from "./Modal.js?vue&type=script&lang=js&"
export * from "./Modal.js?vue&type=script&lang=js&"
import style0 from "./Modal.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports